export const splitFilter = () => {
  return (input, splitChar) => {
    return input.split(splitChar);
  };
};

export const splitNestedByNewlineFilter = () => {
  return (input) => {
    // Join input array, split integrated arrays again and join by newline
    // e.g.: "[['hallo'],['welt']]" --> "hallo\nwelt"
    return (input || '').join(' ').split(',').join('\n');
  };
};

// We already have a limitTo filter built-in to angular,
// let's make a startFrom filter.
export const startFrom = () => {
  return (input, start) => {
    if (input) {
      start = +start; //parse to int
      return input.slice(start);
    }
    return input;
  };
};
